import actions from './actions'

export default function TravelsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_TRAVEL:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_TRAVEL:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_TRAVEL:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_TRAVEL:
      return {
        ...state,
        editing: { travelID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_TRAVEL_RECIEVED ||
      actions.UPDATE_TRAVEL_RECIEVED ||
      actions.DELETE_TRAVEL_RECIEVED:
      return {
        ...state,
        editing: { travelID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
